<script setup>
import { ref } from 'vue';
import { useKaleadicalStore } from '@/stores/kaleadical';
import KaleadicalComponent from '../../components/KaleadicalComponent.vue';
import slider from 'vue3-slider';

const props = defineProps({
    kaleadical: {
        type: Object,
        default: () => ({
            //
        })
    },
    mode: {
        type: String,
        default: 'Create'
    }
});

const { updateKaleadicalScale } = useKaleadicalStore();

const scale = ref(props.kaleadical.scale);

const updateScale = (value) => {
    updateKaleadicalScale(props.kaleadical, { scale: value });
};
</script>

<template>
<MainContentLayout>
    <template #title>View Kaleadical {{ props.kaleadical.name }}</template>
    <div style="height: calc(100vh - 13rem)" class="space-y-3 pb-3">
        <KaleadicalComponent :kaleadical="kaleadical" :scale="scale" />
        <slider
            v-model="scale"
            :always-show-handle="true"
            color="#FB278D"
            :handle-scale="2.5"
            :min="0"
            :max="2"
            :step="0.1"
            track-color="#bababa"
            @drag-end="updateScale" />
    </div>
</MainContentLayout>
</template>
